// @ts-ignore
import {HttpClient, HttpParams} from '@angular/common/http';
// @ts-ignore
import {Injectable} from '@angular/core';
// @ts-ignore
import {Observable} from 'rxjs';

export interface NotaControlIdentificacaoDps {
    serieDps?: string | null;
    numDps?: string | null;
}

export interface NotaControlIdentificacaoPessoaEmpresa {
    cnpj?: string | null;
    cpf?: string | null;
    inscricaoMunicipal?: string | null;
}

export interface NotaControlMensagemRetorno {
    codigo?: string | null;
    mensagem?: string | null;
    correcao?: string | null;
}

export interface NotaControlDpsDisponivel {
    identificacao?: NotaControlIdentificacaoDps | null;
    outrosCampos?: Record<string, string> | null;
}

export interface NotaControlConsultarDpsDisponivelResultado {
    prestador?: NotaControlIdentificacaoPessoaEmpresa | null;
    dpsDisponiveis?: NotaControlDpsDisponivel[] | null;
    pagina?: number | null;
    mensagens?: NotaControlMensagemRetorno[] | null;
}

/** Resultado das consultas ABRASF 2.04 (producao) -- sem parsing tipado, so o XML bruto + mensagens (ver AbrasfConsultaResultado no backend). */
export interface NotaControlAbrasfResultado {
    operacao?: string | null;
    mensagens?: NotaControlMensagemRetorno[] | null;
    respostaXmlBruta?: string | null;
}

/**
 * Chama os endpoints /api/notacontrol/** do gateway (backend GPL-Integracao) --
 * integracao de NFS-e com o provedor Nota Control. Hoje so a consulta de
 * DPS disponivel (leitura), usada para testar a comunicacao com o webservice.
 */
// @ts-ignore
@Injectable({providedIn: 'root'})
export class NotaControlGatewayService {
    private readonly apiUrl = '/api/notacontrol';

    constructor(private readonly http: HttpClient) {
    }

    consultarDpsDisponivel(pagina: number = 1): Observable<NotaControlConsultarDpsDisponivelResultado> {
        const params = new HttpParams().set('pagina', pagina);
        return this.http.get<NotaControlConsultarDpsDisponivelResultado>(`${this.apiUrl}/dps-disponivel`, {params});
    }

    // ---- ABRASF 2.04 (producao, endpoint legado por municipio) ----

    consultarNfseServicoPrestado(dataInicial: string, dataFinal: string, pagina: number = 1): Observable<NotaControlAbrasfResultado> {
        let params = new HttpParams().set('pagina', pagina);
        if (dataInicial) params = params.set('dataInicial', dataInicial);
        if (dataFinal) params = params.set('dataFinal', dataFinal);
        return this.http.get<NotaControlAbrasfResultado>(`${this.apiUrl}/abrasf/nfse-servico-prestado`, {params});
    }

    consultarNfsePorRps(numero: string, serie: string, tipo: string = '1'): Observable<NotaControlAbrasfResultado> {
        const params = new HttpParams().set('numero', numero).set('serie', serie).set('tipo', tipo);
        return this.http.get<NotaControlAbrasfResultado>(`${this.apiUrl}/abrasf/nfse-por-rps`, {params});
    }

    consultarNfsePorFaixa(numeroInicial: string, numeroFinal: string, pagina: number = 1): Observable<NotaControlAbrasfResultado> {
        const params = new HttpParams().set('numeroInicial', numeroInicial).set('numeroFinal', numeroFinal).set('pagina', pagina);
        return this.http.get<NotaControlAbrasfResultado>(`${this.apiUrl}/abrasf/nfse-por-faixa`, {params});
    }

    consultarUrlNfse(numeroNfse: string): Observable<NotaControlAbrasfResultado> {
        const params = new HttpParams().set('numeroNfse', numeroNfse);
        return this.http.get<NotaControlAbrasfResultado>(`${this.apiUrl}/abrasf/url-nfse`, {params});
    }

    consultarDadosCadastrais(): Observable<NotaControlAbrasfResultado> {
        return this.http.get<NotaControlAbrasfResultado>(`${this.apiUrl}/abrasf/dados-cadastrais`);
    }
}
